import React, { useEffect, useState } from "react";
import "./CommentTree.css";
import CommentItem from "./CommentItem/CommentItem";
import { useDispatch } from "react-redux";
import { resetReplyIds } from "../../Redux/CommentSlice";

const data = [
  {
    id: 1677252427307,
    title: "hello",
    userId: 1677252427307,
    isShowReply: false,
    trackId: 1677252427307,
    replys: [
      {
        id: 1677252434572,
        title: "hello world",
        userId: 1677252434572,
        isShowReply: false,
        trackId: 1677252434572,
        replys: [
          {
            id: 1677252449713,
            title: "hello many many many many time",
            userId: 1677252449713,
            isShowReply: false,
            trackId: 1677252449713,
            replys: [],
          },
        ],
      },
    ],
  },
  {
    id: 1677252457839,
    title: "react js",
    userId: 1677252457839,
    isShowReply: false,
    trackId: 1677252457839,
    replys: [
      {
        id: 1677252468098,
        title: "javascript",
        userId: 1677252468098,
        isShowReply: false,
        trackId: 1677252468098,
        replys: [],
      },
    ],
  },
];

function CommentTree() {
  const dispatch = useDispatch();
  const [treeData, setTreeData] = useState(data);

  useEffect(() => {
    return () => dispatch(resetReplyIds());
  }, [dispatch]);

  return (
    <>
      <CommentItem treeData={treeData} />
    </>
  );
}

export default CommentTree;
